import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { Formik } from "formik";
import ErrorMessage from "../ErrorMessage";
import { API_REQUEST } from "../../redux/action";
import { saveVisitorEmailAPI } from "../../routes/apiEndPoints";
import { visitorEmailSchema } from "../../utils/schema";

const VISITOR_EMAIL_STORAGE_KEY = "rc101_visitor_email_collected";

const VisitorEmailPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [modalContent, setModalContent] = useState({
  title: "",
  description: "",
});

useEffect(() => {
  const hasSubmittedEmail = localStorage.getItem(
    VISITOR_EMAIL_STORAGE_KEY
  );

  setIsOpen(!hasSubmittedEmail);
  getVisitorContent();
}, []);

  const getVisitorContent = async () => {
  try {
    const response = await API_REQUEST({
      url: "get-visitor-content",
      method: "GET",
      isErrorToast: true,
    });

    if (response?.success) {
      setModalContent({
        title: response?.data?.title || "",
        description: response?.data?.description || "",
      });
    }
  } catch (error) {
    console.log(error);
  }
};

  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);

    try {
      const response = await API_REQUEST({
        url: saveVisitorEmailAPI,
        method: "POST",
        data: values,
        isErrorToast: true,
      });

      if (response?.success) {
        localStorage.setItem(VISITOR_EMAIL_STORAGE_KEY, "true");
        setIsOpen(false);
        resetForm();
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      open={isOpen}
      footer={null}
      closable={false}
      maskClosable={false}
      keyboard={false}
      centered
      // style={{maxWidth:'500px' , width:'100% !important'}}
      className="ct_visitor_email_modal"
    >
      <div className="ct_visitor_email_modal_body">
        <div className="d-flex justify-content-end align-items-center mb-4">
          {/* <p className="ct_visitor_email_badge mb-0">Stay Connected</p> */}
          <div className="close-icon-cust" onClick={()=>{
            setIsOpen(false)
             localStorage.setItem(VISITOR_EMAIL_STORAGE_KEY, "true");
          }}>
            <i class="fa-solid fa-x "></i>
          </div>
        </div>
        <h3 className="mb-1"> {modalContent?.title || "Welcome to Robot Combat 101"}</h3>
        <p className="mb-4 pb-3">
         {modalContent?.description ||
    "Please enter your email to continue. Your email will be securely stored and you won't be asked again."}

        </p>

        <Formik
          initialValues={{ email: "" }}
          validationSchema={visitorEmailSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="ct_input-group mb-4">
                <input
                  type="email"
                  name="email"
                  id="visitor-email"
                  placeholder="Enter your email"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.email}
                  autoComplete="email"
                  className="ct_input"
                  style={{ height: "50px" }}
                />
                <label className="ct_user-label" htmlFor="visitor-email">
                  Email Address
                </label>
                <ErrorMessage
                  errors={errors}
                  touched={touched}
                  fieldName="email"
                />
              </div>

              <button
                type="submit"
                className="btn btn-secondary ct_btn_animate w-100"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default VisitorEmailPopup;
